import React from "react"
import { useSorts } from "../../Common/Hooks/useSorts"
import Sorting from "../Sorting"
import { OutcomeLink } from "../Filtering/OutcomeLink"
import { OutcomeTypeLink } from "../Filtering/OutcomeTypeLink"
import { Play } from "../../Common/SI"
import { SortToggle } from "../SortToggle"

export interface OutcomeTypeTableProps {
	plays: Play[]
}

export const OutcomeTypeTable = React.memo(function (props: OutcomeTypeTableProps): JSX.Element {

	const table = 'OutcomeType'

	const { sorts } = useSorts()
	const sort = sorts.get(table) || { field: 'section', ascending: true }

	const victoryHeader: TableRow = {
		section: 1,
		title: 'Victory',
		count: 0,
	}

	const lossHeader: TableRow = {
		section: 2,
		title: 'Loss',
		count: 0,
	}

	const victoryRows: Map<string, TableRow> = new Map()
	const lossRows: Map<string, TableRow> = new Map()

	for (const play of props.plays) {

		let header: TableRow
		let rows: Map<string, TableRow>

		if (play.outcome.victory) {
			header = victoryHeader
			rows = victoryRows
		} else {
			header = lossHeader
			rows = lossRows
		}

		let row = rows.get(play.outcome.type)
		if (!row) {
			row = {
				section: header.section,
				title: play.outcome.type || (play.outcome.victory ? '[Unknown victory]' : '[Unknown loss]'),
				count: 0,
			}
			rows.set(play.outcome.type, row)
		}

		row.count = (row.count || 0) + 1
		header.count = (header.count || 0) + 1
	}

	const headers = [
		victoryHeader,
		lossHeader,
	]

	const victoryTableData = Array.from(victoryRows.values())
	const lossTableData = Array.from(lossRows.values())

	Sorting.sort(headers, sort, 'section')
	Sorting.sort(victoryTableData, sort, 'title')
	Sorting.sort(lossTableData, sort, 'title')

	const allDetailRows = [
		...victoryTableData,
		...lossTableData,
	]

	const total = (victoryHeader.count || 0) + (lossHeader.count || 0)

	return (
		<div>
			<table className="stats outcomes">
				<thead>
					<tr>
						<th>
							<SortToggle table={table} field={'section'} label='Outcome' defaultAscending={true} />
						</th>
						<th>
							<SortToggle table={table} field={'count'} label='Count' />
						</th>
						<th>Percentage</th>
					</tr>
				</thead>
				<tbody>
					{
						headers.map(header => (
							<React.Fragment key={header.section}>
								<tr className="subhead">
									<th>
										<OutcomeLink victory={header.section === 1} />
									</th>
									<td>{header.count}</td>
									<td>{total ? `${(100 * (header.count || 0) / total).toFixed(1)}%` : ''}</td>
								</tr>
								{
									allDetailRows
										.filter(detail => detail.section === header.section)
										.map(detail => (
											<tr className="sub" key={detail.title}>
												<th>
													<OutcomeTypeLink outcomeType={detail.title} />
												</th>
												<td>{detail.count}</td>
												<td>{total ? `${(100 * (detail.count || 0) / total).toFixed(1)}%` : ''}</td>
											</tr>
										))
								}
							</React.Fragment>
						))
					}
					<tr className="subhead">
						<th>Total</th>
						<td>{total}</td>
						<td></td>
					</tr>
				</tbody>
			</table>
		</div>
	)
})

interface TableRow {
	section: number
	title: string
	count: number | null
}
